import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import "./links.css";

const Links = ({ cl = "" }) => {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <ul className={`topList ` + cl}>
      <li className="topListItem">
        <Link className="link" to="/">
          HOME
        </Link>
      </li>
      <li className="topListItem">
        <Link className="link" to="/articles">
          ARTICLES
        </Link>
      </li>
      <li className="topListItem">
        <Link className="link" to="/about">
          ABOUT
        </Link>
      </li>
      <li className="topListItem">
        <Link className="link" to="/contact">
          CONTACT
        </Link>
      </li>
      {user && (
        <li className="topListItem">
          <Link className="link" to="/write">
            WRITE
          </Link>
        </li>
      )}
      {user && (
        <li
          className="topListItem"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          LOGOUT
        </li>
      )}
    </ul>
  );
};

export default Links;
